import * as Yup from 'yup';
import { errorMessages } from '~/constants/errorMessages.js';
import { TRevokeFormValues } from '../types.ts';
import {
  phoneValidation,
  emailValidation,
  conditionalClientTypeValidation,
} from '../validationUtils.ts';

export const validationSchemaClientRevoke: Yup.ObjectSchema<TRevokeFormValues> = Yup.object({
  financialServices: Yup.boolean().defined(),
  financialServicesClientType: conditionalClientTypeValidation('financialServices')
    .nullable()
    .defined(),
  cardAccess: Yup.boolean().defined(),
  businessRelationship: Yup.boolean().defined(),
  businessRelationshipClientType: Yup.object()
    .shape({
      value: Yup.string().required(errorMessages.FIELD_REQUIRED),
      label: Yup.string().required(errorMessages.FIELD_REQUIRED),
    })
    .nullable()
    .defined(),
  creditBureauData: Yup.boolean().defined(),
  otherReasonCheckbox: Yup.boolean().defined(),
  otherReason: Yup.string()
    .trim()
    .nullable()
    .defined()
    .when('otherReasonCheckbox', {
      is: true,
      then: (schema) => schema.required(errorMessages.FIELD_REQUIRED),
      otherwise: (schema) => schema.nullable(),
    }),
  phone: phoneValidation.defined(),
  email: emailValidation.defined(),
  atLeastOneCheckbox: Yup.boolean().defined(),
}).test('at-least-one-checkbox', errorMessages.AT_LEAST_ONE_SELECTED, function (values) {
  if (!values) return true;
  const { financialServices, cardAccess, businessRelationship, otherReasonCheckbox } =
    values as TRevokeFormValues;
  const filled = [financialServices, cardAccess, businessRelationship, otherReasonCheckbox].filter(
    Boolean
  );
  if (filled.length) return true;
  return this.createError({
    path: 'atLeastOneCheckbox',
    message: errorMessages.AT_LEAST_ONE_SELECTED,
  });
});
